/**
 * breakpoint.md (768px): below it a public page is app-like - the dock, one tab at a time, the
 * timetable's list of days (docs/public-page.md, docs/events.md).
 */
export const COMPACT_VIEWPORT = '(max-width: 767.98px)'
